import axios from 'axios'

const state = () => ({
  ourService: []
})

const getters = {
  ourService(state) {
    return state.ourService
  }
}

const mutations = {
  SET_OURSERVICE(state, payload){
    state.ourService = payload
  }
}

const actions = {
  getOurService({commit}){
    axios.get('https://api.geomalaka.uz/api/about/bizning-xizmatlar/')
    .then((res)=>{
      commit("SET_OURSERVICE", res.data)
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  }
}

export default{
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}

